import Drawer from '@material-ui/core/Drawer';
import {omit} from 'lodash';
import React, {useState} from 'react';

import {ResizableDrawer} from '../../common/ResizableDrawer/ResizableDrawer';
import * as S from './LinksDrawer.styles';
import {
  LinksDrawerContent,
  LinksDrawerContentProps,
} from './LinksDrawerContent';

export type LinksDrawerProps = LinksDrawerContentProps & {
  open: boolean;
};

export const LinksDrawer = (props: LinksDrawerProps) => {
  const {children, open, closeDrawer} = props;
  const [width, setWidth] = useState(500); // Remember last size
  const onSetWidth = (newWidth: number) => {
    setWidth(newWidth);
  };
  return (
    <Drawer
      anchor="right"
      open={open}
      onClose={closeDrawer}
      variant="persistent">
      <ResizableDrawer
        startWidth={width}
        minWidth={400}
        onSetWidth={onSetWidth}>
        <S.DrawerContents>
          <LinksDrawerContent {...omit(props, ['children'])}>
            {children}
          </LinksDrawerContent>
        </S.DrawerContents>
      </ResizableDrawer>
    </Drawer>
  );
};
